import { useState } from 'react'
import { Calendar } from '@/components/Calendar'

/* ---------- helpers ---------- */

function Section ({
	title,
	children
}: {
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-16'>
			<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
				{title}
			</h3>
			{children}
		</div>
	)
}

/* ---------- sandbox ---------- */

export function CalendarSandbox () {
	const [uncontrolledValue, setUncontrolledValue] = useState<string | undefined>(
		undefined
	)

	const today = new Date()
	const [selectedValue, setSelectedValue] = useState<string | undefined>(
		undefined
	)
	const [month, setMonth] = useState(today.getMonth())
	const [year, setYear] = useState(today.getFullYear())

	const [minValue, setMinValue] = useState<string | undefined>(undefined)

	const pad = (n: number) => n.toString().padStart(2, '0')
	const todayIso = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(
		today.getDate()
	)}`

	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			{/* ── No value (default) ── */}
			<Section title='No Value'>
				<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:w-[280px]'>
					<Calendar value={uncontrolledValue} onValueChange={setUncontrolledValue} />
					<span className='spaces:text-12 spaces:text-content-3'>
						Value: {uncontrolledValue ?? '—'}
					</span>
				</div>
			</Section>

			{/* ── With selected date ── */}
			<Section title='With Selected Date'>
				<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:w-[280px]'>
					<Calendar
						value={selectedValue ?? todayIso}
						onValueChange={setSelectedValue}
						month={month}
						year={year}
						onMonthChange={(m, y) => {
							setMonth(m)
							setYear(y)
						}}
					/>
					<span className='spaces:text-12 spaces:text-content-3'>
						Value: {selectedValue ?? todayIso}
					</span>
				</div>
			</Section>

			{/* ── Min date (today) ── */}
			<Section title='Min Date (today)'>
				<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:w-[280px]'>
					<Calendar
						value={minValue}
						onValueChange={setMinValue}
						minDate={todayIso}
					/>
					<span className='spaces:text-12 spaces:text-content-3'>
						Value: {minValue ?? '—'} · min: {todayIso}
					</span>
				</div>
			</Section>
		</div>
	)
}
